import { createSlice } from "@reduxjs/toolkit";

interface NavigationBlockState {
	isNavigationBlocked: boolean;
}

const initialState: NavigationBlockState = {
	isNavigationBlocked: false,
};

const navigationBlockSlice = createSlice({
	name: "navigationBlock",
	initialState,
	reducers: {
		setNavigationBlocked(state, action) {
			state.isNavigationBlocked = action.payload;
		},
	},
});

export default navigationBlockSlice;
